// @flow
import { OFFER_LEGAL_INFORMATION } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_OFFER_LEGAL_INFORMATION } from 'Utils/request/requestDictionary';

type LineProps = {
  offerId: string,
  seeMore: string,
};

export const offerLegalInformationResolver = {
  name: OFFER_LEGAL_INFORMATION,
  resolve(appContext: AppContext, props: LineProps) {
    const { offerId } = props;
    const query = `
    {
      offer(offerId: "${offerId}") {
        legalInformation
      },
      config {
        common {
          loadLess
        }
      }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_OFFER_LEGAL_INFORMATION,
      strictErrors: false,
    });
  },
};
